/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BuslineScheduleDetailQueryResponse,
  BuslineSchedulesQueryResponse,
  DriverSchedulesQueryResponse,
  FavoriteBuslineScheduleBody,
  GetBuslineSchedulesParams,
  GetDriverSchedulesParams
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getBuslineSchedules = (
    params: GetBuslineSchedulesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<BuslineSchedulesQueryResponse>(
      {url: `/api/v1/busline-schedules`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBuslineSchedulesQueryKey = (params: GetBuslineSchedulesParams,) => {
    return [`/api/v1/busline-schedules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBuslineSchedulesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedules>>, GetBuslineSchedulesParams['page']>, TError = ErrorType<unknown>>(params: GetBuslineSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData, Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']> = ({ signal, pageParam }) => getBuslineSchedules({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData, Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineSchedulesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineSchedules>>>
export type GetBuslineSchedulesInfiniteQueryError = ErrorType<unknown>


export function useGetBuslineSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedules>>, GetBuslineSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData, Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedules>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedules>>, GetBuslineSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData, Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedules>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedules>>, GetBuslineSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData, Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedules>>, GetBuslineSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData, Awaited<ReturnType<typeof getBuslineSchedules>>, QueryKey, GetBuslineSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineSchedulesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(params: GetBuslineSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineSchedules>>> = ({ signal }) => getBuslineSchedules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineSchedules>>>
export type GetBuslineSchedulesQueryError = ErrorType<unknown>


export function useGetBuslineSchedules<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedules>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedules<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedules>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedules<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineSchedules<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(params: GetBuslineSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineSchedules>>> = ({ signal }) => getBuslineSchedules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineSchedules>>>
export type GetBuslineSchedulesSuspenseQueryError = ErrorType<unknown>


export function useGetBuslineSchedulesSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedulesSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedulesSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineSchedulesSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedules>>, TError = ErrorType<unknown>>(
 params: GetBuslineSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getBuslineSchedule = (
    id: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<BuslineScheduleDetailQueryResponse>(
      {url: `/api/v1/busline-schedules/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBuslineScheduleQueryKey = (id: number,) => {
    return [`/api/v1/busline-schedules/${id}`] as const;
    }

    
export const getGetBuslineScheduleInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedule>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineScheduleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineSchedule>>> = ({ signal }) => getBuslineSchedule(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineScheduleInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineSchedule>>>
export type GetBuslineScheduleInfiniteQueryError = ErrorType<unknown>


export function useGetBuslineScheduleInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedule>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedule>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineScheduleInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedule>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedule>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineScheduleInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedule>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineScheduleInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslineSchedule>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineScheduleInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineScheduleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineSchedule>>> = ({ signal }) => getBuslineSchedule(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineSchedule>>>
export type GetBuslineScheduleQueryError = ErrorType<unknown>


export function useGetBuslineSchedule<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedule>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedule<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslineSchedule>>,
          TError,
          Awaited<ReturnType<typeof getBuslineSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSchedule<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineSchedule<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineScheduleQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineScheduleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineScheduleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslineSchedule>>> = ({ signal }) => getBuslineSchedule(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineScheduleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslineSchedule>>>
export type GetBuslineScheduleSuspenseQueryError = ErrorType<unknown>


export function useGetBuslineScheduleSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineScheduleSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineScheduleSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineScheduleSuspense<TData = Awaited<ReturnType<typeof getBuslineSchedule>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslineSchedule>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineScheduleSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const favoriteBuslineSchedule = (
    buslineId: number,
    favoriteBuslineScheduleBody: BodyType<FavoriteBuslineScheduleBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<BuslineSchedulesQueryResponse>(
      {url: `/api/v1/busline-schedules/${buslineId}/favorite`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: favoriteBuslineScheduleBody
    },
      options);
    }
  


export const getFavoriteBuslineScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteBuslineSchedule>>, TError,{buslineId: number;data: BodyType<FavoriteBuslineScheduleBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof favoriteBuslineSchedule>>, TError,{buslineId: number;data: BodyType<FavoriteBuslineScheduleBody>}, TContext> => {
    
const mutationKey = ['favoriteBuslineSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof favoriteBuslineSchedule>>, {buslineId: number;data: BodyType<FavoriteBuslineScheduleBody>}> = (props) => {
          const {buslineId,data} = props ?? {};

          return  favoriteBuslineSchedule(buslineId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FavoriteBuslineScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof favoriteBuslineSchedule>>>
    export type FavoriteBuslineScheduleMutationBody = BodyType<FavoriteBuslineScheduleBody>
    export type FavoriteBuslineScheduleMutationError = ErrorType<unknown>

    export const useFavoriteBuslineSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof favoriteBuslineSchedule>>, TError,{buslineId: number;data: BodyType<FavoriteBuslineScheduleBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof favoriteBuslineSchedule>>,
        TError,
        {buslineId: number;data: BodyType<FavoriteBuslineScheduleBody>},
        TContext
      > => {

      const mutationOptions = getFavoriteBuslineScheduleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getDriverSchedules = (
    params: GetDriverSchedulesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<DriverSchedulesQueryResponse>(
      {url: `/api/v1/busline-schedules/driver/schedules`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDriverSchedulesQueryKey = (params: GetDriverSchedulesParams,) => {
    return [`/api/v1/busline-schedules/driver/schedules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDriverSchedulesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDriverSchedules>>, GetDriverSchedulesParams['page']>, TError = ErrorType<unknown>>(params: GetDriverSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData, Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']> = ({ signal, pageParam }) => getDriverSchedules({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData, Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDriverSchedulesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverSchedules>>>
export type GetDriverSchedulesInfiniteQueryError = ErrorType<unknown>


export function useGetDriverSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDriverSchedules>>, GetDriverSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData, Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverSchedules>>,
          TError,
          Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDriverSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDriverSchedules>>, GetDriverSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData, Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverSchedules>>,
          TError,
          Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDriverSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDriverSchedules>>, GetDriverSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData, Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDriverSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDriverSchedules>>, GetDriverSchedulesParams['page']>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData, Awaited<ReturnType<typeof getDriverSchedules>>, QueryKey, GetDriverSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDriverSchedulesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDriverSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(params: GetDriverSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverSchedules>>> = ({ signal }) => getDriverSchedules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDriverSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverSchedules>>>
export type GetDriverSchedulesQueryError = ErrorType<unknown>


export function useGetDriverSchedules<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverSchedules>>,
          TError,
          Awaited<ReturnType<typeof getDriverSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDriverSchedules<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDriverSchedules>>,
          TError,
          Awaited<ReturnType<typeof getDriverSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDriverSchedules<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDriverSchedules<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDriverSchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDriverSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(params: GetDriverSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDriverSchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDriverSchedules>>> = ({ signal }) => getDriverSchedules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDriverSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDriverSchedules>>>
export type GetDriverSchedulesSuspenseQueryError = ErrorType<unknown>


export function useGetDriverSchedulesSuspense<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDriverSchedulesSuspense<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDriverSchedulesSuspense<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDriverSchedulesSuspense<TData = Awaited<ReturnType<typeof getDriverSchedules>>, TError = ErrorType<unknown>>(
 params: GetDriverSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDriverSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDriverSchedulesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



